import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postCommune } from "./ServiceCommune";

import { getAllWilaya } from "../wilaya/ServiceWilaya";

export default function AddCommune() {
 const { t } = useTranslation();
   const { language } = useLanguage();
  const navigate = useNavigate();

  const [data, setData] = useState({
    codeCommune: "",
    commune: "",
    communeArab: "",
    communeAng: "",
    wilayaId: "",
  });

  const [wilayas, setWilayas] = useState([]);

  const [errorMessage, setErrorMessage] = useState({});

  // Gestion des champs
  const onInputchange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  // charger la wiliay

  const loadWilayas = async () => {
    try {

      const result = await getAllWilaya();

      const sortedData = [...result.data].sort(
        (a, b) =>
          Number(a.codeWilaya) -
          Number(b.wilaya)
      );

      setWilayas(sortedData);

    } catch (error) {
      //console.log(error);
    }
  };

  useEffect(() => {
    loadWilayas();
  }, []);

  // Enregistrement
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        codeCommune: data.codeCommune,
        commune: data.commune,
        communeArab: data.communeArab,
        communeAng: data.communeAng,
        wilaya: {
          id: Number(data.wilayaId)
        }
      };

      await postCommune(payload);

      toast.success(t("commune.saveSuccess"), {
        position: "bottom-right",
        autoClose: 2000,
      });

      setData({
        codeCommune: "",
        commune: "",
        communeArab: "",
        communeAng: "",
        wilayaId: "",
      });

      setErrorMessage({});

      navigate("/listcommune");

    } catch (error) {

      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {

        const errorArray = error.response.data.errors;

        // Construction du toast
        const formattedErrors = errorArray.map((err, index) => {

          const msg =
            err.indexOf(":") > -1
              ? err.split(":")[1]
              : err;

          return (
            <li key={index} className="list-group-item">
              {msg}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "18rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">
                {t("common.validationErrors")}
              </h5>
            </div>

            <div className="card-body">
              <ul className="list-group list-group-flush">
                {formattedErrors}
              </ul>
            </div>
          </div>,
          {
            position: "bottom-right",
            autoClose: 4000,
          }
        );

        const errorObject = {};

        errorArray.forEach((err) => {

          if (err.indexOf(":") > -1) {

            const [field, message] = err.split(":");

            errorObject[field.trim()] = message.trim();
          }
        });

        setErrorMessage(errorObject);

      } else {

        toast.error("Erreur lors de l'enregistrement");

        console.error(error);
      }
    }
  };

  return (
    <div
      className="div-width"
      style={{ marginTop: "6rem" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">

          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>

            <Link
              className="mx-2"
              to="/"
            >
               {t("menu.home")}
            </Link>
          </li>

          <li className="breadcrumb-item">
            <Link
              className="mx-2"
              to="/Listcommune"
            >
               {t("commune.titre")}
            </Link>
          </li>

          <li className="breadcrumb-item active">
             {t("commune.new")}
          </li>

        </ol>
      </nav>

      <div className="table-container">

        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-folder-plus fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">

          <h4 className="ajst-titre mb-4">
            {t("commune.new")}
          </h4>

          <form onSubmit={onSubmit}>

            <div className="row justify-content-center">

              <div className="col-md-6">

                {/* Wilaya */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("wilaya.titre")}
                  </label>

                  <select
                    className={`form-select ${errorMessage.wilayaId ? "is-invalid" : ""
                      }`}
                    name="wilayaId"
                    value={data.wilayaId}
                    onChange={onInputchange}
                    required
                  >

                    <option value="">
                        {t("common.select")}
                    </option>

                     {wilayas.map((w) => (
                        <option
                          key={w.id}
                          value={w.id}
                        >
                          {w.codeWilaya} - {getLabel(w, "wilaya", language)}
                        </option>
                      ))}

                  </select>

                  {errorMessage.wilayaId && (
                    <div className="text-danger mt-1">
                      {errorMessage.wilayaId}
                    </div>
                  )}

                </div>

                {/* commune FR */}
                <div className="mb-3">

                  <label className="form-label required-label">
                     {t("common.code")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="codeCommune"
                    value={data.codeCommune}
                    onChange={onInputchange}
                  />

                  {errorMessage.commune && (
                    <div className="text-danger mt-1">
                      {errorMessage.codeCommune}
                    </div>
                  )}

                </div>


                {/* commune FR */}
                <div className="mb-3">

                  <label className="form-label required-label">
                     {t("common.french")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="commune"
                    value={data.commune}
                    onChange={onInputchange}
                  />

                  {errorMessage.commune && (
                    <div className="text-danger mt-1">
                      {errorMessage.commune}
                    </div>
                  )}

                </div>

                {/* commune {t("common.arabic")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.arabic")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="communeArab"
                    value={data.communeArab}
                    onChange={onInputchange}
                    dir="rtl"
                  />

                  {errorMessage.communeArab && (
                    <div className="text-danger mt-1">
                      {errorMessage.communeArab}
                    </div>
                  )}

                </div>

                {/* commune {t("common.english")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.english")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="communeAng"
                    value={data.communeAng}
                    onChange={onInputchange}
                  />

                  {errorMessage.communeAng && (
                    <div className="text-danger mt-1">
                      {errorMessage.communeAng}
                    </div>
                  )}

                </div>

              </div>

            </div>

            <div className="text-center mt-4">

              <button
                type="submit"
                className="btn btn-outline-primary"
              >
                {t("button.save")}
              </button>

              <Link
                to="/Listcommune"
                className="btn btn-outline-success mx-2"
              >
                {t("button.close")}
              </Link>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}